import { InventorySubType } from './InventorySubType';
export class InventoryType {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
        this.inventorySubTypes = json.asset_conditions.map((subType) => new InventorySubType(subType));
    }
}
//# sourceMappingURL=InventoryType.js.map